(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dual-product-images"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dualProductImagesScrollInit) return;
    window.__dualProductImagesScrollInit = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.dual-product-images [data-scroll-to]');
      if (!trigger) return;

      var targetId = trigger.getAttribute('data-scroll-to');
      if (!targetId) return;

      var target = document.getElementById(targetId) || document.querySelector('[data-scroll-call="' + targetId + '"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
